<script setup lang="ts">
import { formatDate } from "~/helpers/date";

type Props = {
  startDate: string;
  endDate?: string | null;
};

defineProps<Props>();
</script>

<template>
  <span class="flex items-center gap-1.5">
    <UIcon
      name="i-custom-calendar"
      :size="16"
      mode="svg"
      aria-hidden="true"
      class="text-gray-700 dark:text-primary-100 self-center"
    />
    <div
      class="inline-flex gap-x-1 lg:text-sm text-gray-700 dark:text-primary-100"
    >
      <time :datetime="startDate">{{ formatDate(startDate) }}</time>
      <span>-</span>
      <time v-if="endDate" :datetime="endDate">{{ formatDate(endDate) }}</time>
      <span v-else>Present</span>
    </div>
  </span>
</template>
